<div class="barSelect">
  <div class="barSelect-content" [ngClass]="inBasketPage?'inBasketPage':''">
    <div class="leftContent">
      <span class="nbOfBasketElements">{{'GLOBAL.selectedItems' | translate: {nbItems: nexiaBasketObjects.length} }}</span>
    </div>
    <div class="rightContent">
      <span class="selectAll" (click)="allSelected?onRemoveAllToBasket():onAddAllToBasket()">{{allSelected? ('GLOBAL.deselectAll'| translate) : ('GLOBAL.selectAll' | translate) }}</span>
      <ng-content></ng-content>
      <span class="closeIcon icon icon-close" (click)="onClick()"></span>
    </div>
  </div>
</div>
